import gql from 'graphql-tag';

export const attributionFragment = gql`
  fragment attributionFragment on Attribution {
    id
    attributionType
    name
  }
`;
export default attributionFragment;
